import React from "react";
import { InputRangeRow } from "./index";
// Used by Hacoba NSA-HS and Taining S41 machines

export default function TensionPostSettingRow() {
   return (
      <InputRangeRow
         titleProp={"Tension Post Setting"}
         descriptionProp={""}
         sizeProp={4}
         typeProp={"text"}
         minProp={0}
         maxProp={9}
         propertyNameProp={"tensionPostSet"}
         errorDialogueProp={"0.00-9.00 only"}
         floatProp={true}
      />
   );
}
